<!-- WCAG 2.4.1 Bypass Blocks: keyboard users can jump straight to <main>. -->
<a class="skip-link" href="#main-content" (click)="skipToMain($event)">Skip to main content</a>

<mat-sidenav-container class="app-shell">
  @if (isAuthed()) {
    <mat-sidenav [mode]="sidenavMode()" [opened]="drawerOpened()" (closed)="drawerOpened.set(false)" class="app-sidenav">
      <div class="app-brand">
        <!-- NDE agency mark. Real alt text (not decorative): "Nevada Department
             of Education" is the one thing the adjacent brand copy never says. -->
        <img
          class="app-brand-logo"
          src="assets/nde-logo.png"
          alt="Nevada Department of Education"
          width="360"
          height="140"
        />
        <p class="app-brand-title">NEPF Portal</p>
        <p class="app-brand-subtitle">Nevada Educator Performance Framework</p>
      </div>
      <!-- NAV-01/NAV-04: the sidenav renders from the single typed NAV_GROUPS
           config (see core/nav/nav-config.ts) — NOT scattered per-item canSee()
           gates. Each group renders its header only when it has visible items;
           Records routes via the per-role resolver (NAV-02 #1 fix); Diagnostics is
           a separated footer link. -->
      <mat-nav-list (click)="onNavClick()" class="app-nav-list">
        @for (g of navGroups; track g.group) {
          @if (visibleItems(g.group); as items) {
            @if (items.length) {
              <div mat-subheader>{{ g.header }}</div>
              @for (item of items; track item.route) {
                <a
                  mat-list-item
                  [routerLink]="item.route === '/records' ? recordsRoute() : item.route"
                  routerLinkActive="active-link"
                  #rla="routerLinkActive"
                  [routerLinkActiveOptions]="item.route === '/dashboard' ? { exact: true } : {}"
                  [attr.aria-current]="rla.isActive ? 'page' : null"
                >
                  <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
                  <span matListItemTitle>{{ item.label }}</span>
                </a>
              }
            }
          }
        }

        <!-- NAV-08: footer Diagnostics link (/claims) — separated from the main
             groups, not a primary nav item. -->
        <mat-divider></mat-divider>
        <a
          mat-list-item
          routerLink="/claims"
          routerLinkActive="active-link"
          #rlaDiag="routerLinkActive"
          [attr.aria-current]="rlaDiag.isActive ? 'page' : null"
        >
          <mat-icon matListItemIcon>bug_report</mat-icon>
          <span matListItemTitle>Diagnostics</span>
        </a>
      </mat-nav-list>
    </mat-sidenav>
  }

  <mat-sidenav-content>
    <mat-toolbar color="primary">
      @if (isAuthed()) {
        <button mat-icon-button aria-label="Toggle menu" (click)="toggleDrawer()">
          <mat-icon>menu</mat-icon>
        </button>
      }
      <!-- Org name REPLACES the app title when signed in (the sidenav brand
           already says "NEPF Portal"); app title is the logged-out / org-missing
           fallback since the sidenav is hidden pre-auth. -->
      @if (isAuthed() && organizationName(); as org) {
        <span class="app-org" aria-label="Organization">
          <mat-icon aria-hidden="true">apartment</mat-icon>
          <span class="app-org-name">{{ org }}</span>
        </span>
      } @else {
        <span class="app-title">NEPF Upload Portal</span>
      }
      <span class="spacer"></span>
      @if (isAuthed()) {
        <nepf-notification-bell></nepf-notification-bell>
        <span class="username" aria-label="Signed in as">{{ username() }}</span>
        <button mat-icon-button (click)="signOut()" aria-label="Sign out">
          <mat-icon>logout</mat-icon>
        </button>
      }
    </mat-toolbar>

    <main id="main-content" role="main" class="app-main" tabindex="-1">
      <div class="app-main-inner">
        @if (isAuthed()) {
          <nepf-breadcrumbs></nepf-breadcrumbs>
        }
        <router-outlet />
      </div>
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>
